export default {
  routeContainer: {
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    width: '100%',
  },
  component: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/views/Root/styles.js